











































































import Vue from "vue";
import moment from "moment";
import { getEmailRecipients } from "@/helpers/api";

interface State {
  showAllRecipients: boolean;
  search: string;
  fullscreen: boolean;
  recipients: Array<any>;
  headers: Array<any>;
}

export default Vue.extend({
  name: "SentEmailHeader",
  props: {
    email: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showAllRecipients: false,
      search: "",
      fullscreen: false,
      recipients: [],
      headers: [
        {
          text: "Player Name",
          align: "start",
          sortable: true,
          value: "playerName"
        },
        {
          text: "To",
          align: "start",
          sortable: true,
          value: "recipientEmail"
        },
        {
          text: "Type",
          align: "start",
          sortable: true,
          value: "recipientType"
        } /*
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status"
        },*/,
        {
          text: "Opens",
          align: "start",
          sortable: true,
          value: "openCount"
        },
        // {
        //   text: "",
        //   align: "start",
        //   sortable: true,
        //   value: "opens"
        // },
        {
          text: "Clicks",
          align: "start",
          sortable: true,
          value: "clickCount"
        }
        // {
        //   text: "",
        //   align: "start",
        //   sortable: true,
        //   value: "clicks"
        // }
        /*
        {
          text: "Bounce",
          align: "start",
          sortable: true,
          value: "bounceDiag"
        },
        {
          text: "Bounce Reason",
          align: "start",
          sortable: true,
          value: "bounceDescription"
        }
        */
      ]
    };
  },
  mounted() {
    this.loadRecipients();
  },
  methods: {
    async loadRecipients() {
      this.recipients = await getEmailRecipients(this.email.id);
    },
    formatTStoDate(date: string): string {
      const ts = new Date(date);
      const time = ts.getTime() / 1000;
      return moment.unix(time).format("MMM D YYYY, h:mm a");
    },
    fixQuotes(s: string) {
      // so for some reason emails sent through TeamBot stored the orgUnit name with quotes around it in the database
      // so until that is fixed I'm going to just strip them here
      return s.replaceAll('"', "");
    }
  },
  computed: {
    recipientsOpened() {
      const rs: Array<any> = this.recipients;
      return rs ? rs.filter(r => r.openCount > 0) : [];
    },
    recipientsUnopened() {
      const rs: Array<any> = this.recipients;
      return rs ? rs.filter(r => r.openCount === 0) : [];
    },
    sent(): string {
      return moment(this.email.dateCreated).format("MMMM D, YYYY [at] h:mm a");
    },
    sentShort(): string {
      return moment(this.email.dateCreated).format("M/D/YY h:mm");
    },
    subject(): string {
      return this.email.subject;
    }
  },
  watch: {
    email: {
      handler: async function(newVal, oldVal) {
        if (newVal !== oldVal) {
          await this.loadRecipients();
        }
      }
    }
  }
});
